import { render, staticRenderFns } from "./DocumentCommentsUploads.vue?vue&type=template&id=499142ac&scoped=true&"
import script from "./DocumentCommentsUploads.vue?vue&type=script&lang=js&"
export * from "./DocumentCommentsUploads.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCommentsUploads.vue?vue&type=style&index=0&id=499142ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499142ac",
  null
  
)

export default component.exports